export const useSearchStore = defineStore("searchStore", {
    state: () => ({
        query: undefined as string | undefined,
        category: undefined as string | undefined,
    }),
    getters: {
        getQuery(state) {
            return state.query
        },
        getCategory(state) {
            return state.category
        },
    },
    actions: {
        setQuery(newQuery?: string) {
            const router = useRouter()
            if (!newQuery) {
                this.query = router.currentRoute.value.query.query as string
            } else {
                this.query = newQuery
            }
        },
        setCategory(newCategory?: string) {
            const router = useRouter()
            if (!newCategory) {
                this.category = router.currentRoute.value.query
                    .category as string
            } else {
                this.category = newCategory
            }
        },
    },
})
